import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

interface InsightsChartProps {
  data: { date: string; spend: number; roas: number; impressions?: number; clicks?: number }[];
  title?: string;
}

export function InsightsChart({ data, title = "Spend & ROAS" }: InsightsChartProps) {
  if (!data || data.length === 0) {
    return (
      <Card>
        <CardHeader><CardTitle className="text-base">{title}</CardTitle></CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-[300px] text-gray-400">No data available for this period</div>
        </CardContent>
      </Card>
    );
  }

  const formatted = data.map(d => ({
    ...d,
    date: d.date.slice(5),
  }));

  return (
    <Card data-testid="insights-chart">
      <CardHeader><CardTitle className="text-base">{title}</CardTitle></CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <ComposedChart data={formatted}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="date" tick={{ fontSize: 12 }} />
            <YAxis yAxisId="left" tick={{ fontSize: 12 }} tickFormatter={(v) => `$${v}`} />
            <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 12 }} tickFormatter={(v) => `${v}x`} />
            <Tooltip
              formatter={(value: any, name: string) => {
                if (name === "spend") return [`$${parseFloat(value).toFixed(2)}`, "Spend"];
                if (name === "roas") return [`${parseFloat(value).toFixed(2)}x`, "ROAS"];
                return [value, name];
              }}
            />
            <Legend />
            <Bar yAxisId="left" dataKey="spend" fill="#6366f1" radius={[4, 4, 0, 0]} name="Spend" />
            <Line yAxisId="right" type="monotone" dataKey="roas" stroke="#8b5cf6" strokeWidth={2} dot={{ r: 3 }} name="ROAS" />
          </ComposedChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
